import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-whatsapp',
  templateUrl: './whatsapp.component.svg',
})
export class WhatsappComponent extends MedrecordIcon {
  viewHeight = 16;
  viewWidth = 16;
}
